// ============================================================================
// 📁 CommentsBlock.js
// 🎨 Premium SaaS UI — Modern Comment Section
// ============================================================================

import React from "react";
import { Button, Input } from "antd";
const { TextArea } = Input;

export default function CommentsBlock({ comments = [], onAddComment }) {
  const [value, setValue] = React.useState("");

  const handleAdd = () => {
    if (!value.trim()) return;
    onAddComment(value);
    setValue("");
  };

  return (
    <div
      className="tf-block"
      style={{
        background: "#fff",
        padding: "20px 24px",
        borderRadius: "14px",
        marginBottom: "22px",
        border: "1px solid #eee",
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
      }}
    >
      {/* Section Title */}
      <div
        style={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#2a2344",
          marginBottom: "16px",
        }}
      >
        Comments
      </div>

      {/* Input Area */}
      <TextArea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Write a comment..."
        autoSize={{ minRows: 2, maxRows: 5 }}
        style={{
          borderRadius: "10px",
          marginBottom: "12px",
        }}
      />

      <Button
        type="primary"
        onClick={handleAdd}
        style={{
          background: "linear-gradient(90deg,#6A00F4,#D100B8)",
          border: "none",
          padding: "6px 20px",
          fontWeight: 600,
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        Add Comment
      </Button>

      {/* Comments List */}
      {comments.map((c, idx) => (
        <div
          key={idx}
          style={{
            background: "#f4ebff",
            padding: "14px 16px",
            borderRadius: "12px",
            marginBottom: "14px",
            border: "1px solid #eadbff",
          }}
        >
          <div style={{ fontSize: "14px", fontWeight: 600, color: "#5b00e0" }}>
            {c.author_name}
          </div>
          <div style={{ fontSize: "12px", opacity: 0.6 }}>{c.timestamp}</div>
          <div style={{ marginTop: "6px", fontSize: "14px" }}>{c.content}</div>
        </div>
      ))}
    </div>
  );
}
